module.exports = __webpack_public_path__ + "static/media/icon_tick_white.d0e41514.svg";